class VanillaTitleDive {
  constructor(targetClass = "js-ttl", charClass = "js-ttl-char") {
    this.targetClass = targetClass;
    this.charClass = charClass;
    this.elements = document.querySelectorAll(`.${this.targetClass}`);

    this.init();
  }

  init() {
    if (!this.elements.length) return;

    this.elements.forEach((element) => {
      this.split(element);
    });
  }

  split(element) {
    const text = element.textContent.trim();
    const fragment = document.createDocumentFragment();

    element.textContent = "";

    [...text].forEach((char) => {
      const span = document.createElement("span");

      span.classList.add(this.charClass);
      span.textContent = char === " " ? "\u00A0" : char;

      fragment.appendChild(span);
    });

    element.appendChild(fragment);
  }
}

export default VanillaTitleDive;
